// src/AIAgriSection.js
import React from 'react';
import './AIAgriSection.css';

function AIAgriSection() {
  return (
    <div className="aiagri-section">
      <h2>🤖 AI Applications in Farming</h2>
      <div className="ai-cards">
        <div className="ai-card">
          <img src="/images/aicrop.png.jpeg" alt="AI Crop" />
          <h3>Drone Monitoring</h3>
          <p>
            Drones with AI analyze plant health and soil conditions from above for timely actions.
          </p>
        </div>
        <div className="ai-card">
          <img src="/images/genaibanner.jpg.jpeg" alt="GenAI Banner" />
          <h3>Yield Prediction</h3>
          <p>
            AI models predict harvest yields and risks to help farmers make data-driven decisions.
          </p>
        </div>
      </div>
    </div>
  );
}

export default AIAgriSection;
